import { ExclamationIcon } from '@mm/icons';
import { ReactComponent as CheckCircleGreenIcon } from 'assets/check-circle-green.svg';
import classnames from 'classnames';
import React from 'react';
import { toast, ToastPosition } from 'react-toastify';
import { colors } from '../../editor/features/beta/styles/colors';
import './toast.pcss';

export const successToast = (message: string, position?: ToastPosition) => {
  toast(
    <div className="toast__container">
      <CheckCircleGreenIcon />

      {message}
    </div>,
    {
      className: 'toast',
      position,
    },
  );
};

export const errorToast = (
  message: string,
  position?: ToastPosition,
  className?: string,
) => {
  toast(
    <div className={classnames('toast__container', className)}>
      <ExclamationIcon color={colors.danger} />
      {message}
    </div>,
    {
      className: 'toast',
      position,
    },
  );
};
